export default __webpack_public_path__ + "static/media/village.0fe99239.svg";